<template>
  <v-container style="height: 100vh" class="pa-7 d-flex align-center justify-center" fluid>
    <div>
      <h2 class="text-center">{{ $t('promoHeader') }}</h2>
      <div v-if="false" class="d-flex justify-center mt-7">
        <v-btn class="switch-button py-5 px-7" :disabled="forex" @click="changeRanking">
          {{ $t('internalEquitiTournament') }}
          <v-icon small class="ml-2" >fa-euro-sign</v-icon>
        </v-btn>
        <v-btn class="switch-button py-5 px-7" :disabled="!forex" @click="changeRanking">
          {{ $t('futuresRanking') }}
          <v-icon class="ml-2">fa-future</v-icon>
        </v-btn>
      </div>

      <v-row class="mt-10" align="center" justify="center">
        <TournamentRegister :title="$t('internalEquitiTournament')" :subtitle="$t('registerInEquitiTournament')"
                            :enrolled="alreadyEnrolled"
                            :end-time="new Date(2020, 10, 18)" :accounts="accounts" @register="registerTournament"
                            :go-to-path="'https://www.equiticlients.com/Redirect?linkID=0049690'"/>
      </v-row>

      <v-row align="center" justify="center" class="mt-n5 mr-n5">
        <p class="mt-3 mr-n3">{{ $t('sponsoredBy') }}</p>
        <v-img position="center center" src="https://www.theforexgeek.com/wp-content/uploads/2020/10/Equiti-Logo.png"
               laz max-width="150" contain/>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Repository from '../../repositories/tournament';
import TournamentRegister from '../../components/TournamentRegister';
export default {
  name: "RankingIndex",
  components: { TournamentRegister },
  data() {
    return {
      forex: true,
      alreadyEnrolled: false,
      accounts: [],
    };
  },
  mounted() {
    this.verifyIfEnrolled();
  },
  methods: {
    changeRanking() {
      this.forex = !this.forex;
    },
    verifyIfEnrolled() {
      Repository.findParticipantByTournament(8, this.$store.state.user.id).then((response) => {
        if(response.status < 400) {
          this.alreadyEnrolled = response.data !== null;
          if(!this.alreadyEnrolled)
            this.setAccounts();
        }
      });
    },
    setAccounts() {
      this.$store.state.user.brokerAccounts.forEach((account) => {
        if(account.verified && account.broker.name.includes('Equiti'))
          this.accounts.push(account);
      });
    },
    registerTournament(accountSelected) {
      let tournamentParticipant = {
        tournament: { id: 8 },
        assignedAccount: { id: accountSelected },
        user: { id: this.$store.state.user.id },
      };
      Repository.enrollParticipant(tournamentParticipant).then((response) => {
        if (response.status < 400 && response.data) {
          alert(this.$t('congratsMessage',{name:this.$store.state.user.firstName}));
          this.alreadyEnrolled = true;
        }
      });
    },
  },
}
</script>

<style scoped>
  .switch-button {
    color: #ffffff !important;
    background-color: #111111 !important;
    border: 0 !important;
  }
</style>


